import body         from "../../../index.module.scss";
import classes      from "./FirstStep.module.scss";
import AboutSeo     from "./AboutSeo/AboutSeo";
import SolutionList from './SoluionList/SolutionLis';
import Research     from "./Research/Research";
import Final        from "./Final/Final";
import PinkBg       from "../../PinkBlock/PinkBlock";

import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import Cards        from './../../Cards/Cards';
import BoldTitle    from '../../Titles/BoldTitle/BoldTitle';
import Carousel     from '../../Carousel/Carousel';
// Image 
import graph1       from "../../Assets/Img/Src/Slider/1.png"
import graph2       from "../../Assets/Img/Src/Slider/1_1.png"
import graph1Webp   from "../../Assets/Img/Webp/Slider/1.webp"
import graph2Webp   from "../../Assets/Img/Webp/Slider/1_1.webp"

let data = [{
  number: "01.",
  title: "Реклама шла по  очень\u00A0 широкому пулу\u00A0  запросов.",
  text: "Использовались, например, такие общие запросы как\u00A0 «Babor», что приводило к перерасходу бюджета и малой эффективности"
},
{
  number: "02.",
  title: "На 1 пул\u00A0запросов   было\u00A0составлено  \nпо 1 объявлению",
  text: "Это не позволяло\nсистеме тестировать эффективность\n объявлений и \nвыбирать лучшие."
},
{
  number: "03.",
  title: "Был \nвключён    \n«Автотаргетинг» ",
  text: "Что к широкому пулу запросов добавляло\n ещё и похожие."
},
{
  number: "04.",
  title: "Реклама шла без\nучёта и нацеливания на ЦА. ",
  text: " То есть без корректировок по возрасту, полу, интересам пользователей."
},]

const mediaFile = [
  {
    img: graph1 ,
    imgWebp: graph1Webp,
    title: "Общий трафик в начале работ",
  },
  {
    img: graph2 ,
    imgWebp: graph2Webp,
    title: "SEO трафик в начале работ",
  },
]

const FirstStep =  () => {
  return (
    <section id="Analys" className={classes.firstStep}>
      <PinkBg number={1} customClass={classes.PinkBg}/>
      <div className={body.container}>
        <div className={classes.Wrapper}>
        <div className={classes.Analys}>
        <SectionTitle text={<>Анализ <span>текущей ситуации</span> </>} customClass={classes.Title}/>
          <p className={classes.About}>
            В феврале 2018 года мы начали работу над аналитикой,
            SEO-продвижением магазина и взяли сайт на техническую 
            поддержку. На тот момент работала реклама в Я.Директ,
            причём аналитику накопленных данных никто ни разу не 
            проводил.
            <br/>
            <b>Первый же взгляд на данные статистики показал
            нам всю неэффективность, 
            как контекстной рекламы, так и сайта в целом.</b>
          </p>
        <div className={classes.Box}>
          <p className={classes.Text}>
          В дальнейшем Заказчик сменил подрядчика по контекстной рекламе,
          и при создании
          новых кампаний все наши замечания были учтены.
          </p>
        </div>
        </div>
        <div className={classes.Inefficient}>
        <BoldTitle
           text={<>мы выявили следующие Причины неэффективности <span>рекламы</span>:</>}
           customClass={classes.BoldTitle}/>
        <ul className={classes.List}>
          {data.map( (elem, i) => {
            return (
              <li className={classes.Item} key={i} >
                 <Cards
                     number={elem.number}
                     title={elem.title}
                     text={elem.text}
                     customClass={classes.Cards}
                     />
              </li>
            )
          } )}
        </ul>
    
      </div>  
      </div>
        <AboutSeo/>
        <div className={classes.Carousel}>
          <h5 className={classes.Title}>
            Отталкиваясь от этой проблематики,
            мы начали глубже погружаться в анализ
            статистических данных и бизнес-процессов
          </h5>
          <Carousel media={mediaFile} title={true} id="1" />
        </div>
        <SolutionList/>
        <Research/>
        <Final/>
        <PinkBg number={""} customClass={classes.PinkBlock}/>
      </div>
          
    </section>
  )
}

export default FirstStep;